<template>
    <div>
        <el-radio-group v-model="selected_type">
          <el-radio-button v-for="(name, type) in types" :label="type" :key="type">{{ name }}</el-radio-button>
        </el-radio-group>

        <ve-bar v-if="selected_type !== 'heatmap'" :data="chart_data" :settings="chart_settings" :x-axis="xAxisOpts" :height="height" :width="width"></ve-bar>
        <ve-heatmap v-if="selected_type === 'heatmap'" :data="chart_data" :settings="chart_settings" :height="height"  :width="width" :extend="extend"></ve-heatmap>
    </div>
</template>

<script>
  import VeBar from 'v-charts/lib/bar.common'
  import VeHeatmap from 'v-charts/lib/heatmap.common'

  export default {
    name: "Heatmap",
    components: {VeBar, VeHeatmap},
    props: ['data'],
    data: function () {
      return {
        chart_settings_base: {
          dataOrder: {
            label: 'count',
            order: 'desc'
          }
        },
        xAxisOpts: {
          minInterval: 1,
        },
        types: {
          "endpoint": "Endpoint",
          "study_type": "Study type",
          "heatmap": "Heatmap",
        },
        selected_type: "study_type",
        extend: {
          xAxis: {
            axisLabel: {
              rotate: 90
            },
          },
          series(item) {
            item[0].data.forEach(d => {
              d.label = {
                normal: {
                  show: true,
                  formatter(v) {
                    return v.data.value[3]
                  }
                }
              }
            })
            return item
          },
        }
      }
    },
    computed: {
      chart_data: function () {
        let rows = []
        if (this.selected_type === null)
          return {}
        // prepare the data
        let records = [...this.data[this.selected_type]]
        records.reverse()
        // process the data depending on what chart we selected
        if (this.selected_type === 'heatmap') {
          for (let row of records) {
            let [title, study_type, count] = row;
            if (title.length > 20)
              title = title.substr(0, 20) + "...";
            rows.push({'endpoint': title, 'study_type': study_type, 'count': count})
          }
          return {
            columns: ['study_type', 'endpoint', 'count'],
            rows: rows,
          }
        } else {
          for (let row of records) {
            let [title, count] = row;
            if (title.length > 20)
              title = title.substr(0, 20) + "...";
            rows.push({'endpoint': title, 'count': count})
          }
          return {
            columns: ['endpoint', 'count'],
            rows: rows,
          }
        }
      },
      chart_settings: function () {
        let ret = {}
        for (let key in this.chart_settings_base)
          ret[key] = this.chart_settings_base[key];
        if (this.selected_type === "heatmap") {
          ret['yAxisList'] = [...new Set(this.chart_data.rows.map(rec => rec['endpoint']))]
          ret['yAxisList'].sort((a, b) => -a.toLowerCase().localeCompare(b.toLowerCase()))
          ret['xAxisList'] = [...new Set(this.chart_data.rows.map(rec => rec['study_type']))]
          ret['xAxisList'].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
        }
        return ret
      },
      height: function () {
        let height = 0
        if (this.selected_type === 'heatmap')
          height = this.data['endpoint'].length * 20 + 150
        else
          height = this.data[this.selected_type].length * 20 + 150
        return `${height}px`
      },
      width: function () {
        let width = 0
        if (this.selected_type === 'heatmap')
          width = this.data['study_type'].length * 30 + 300
        else
          width = 600
        return `${width}px`
      }
    },
  }
</script>

<style scoped>

</style>
